import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import Home from "./pages/Home";
import Shops from "./pages/Shops";
import Card from "./pages/Card";
import Shipping from "./pages/Shipping";
import Details from "./pages/Details";
import Login from "./pages/Login";
import Register from "./pages/Register";
import { getFirstCompany, getNavMenus } from "./store/reducers/initReducer";
import { get_category, get_typeproduct, get_typearticle, get_brand, get_color, get_size } from "./store/reducers/homeReducer";

import { useDispatch, useSelector } from "react-redux";
import CategoryShop from "./pages/CategoryShop";
import SearchProducts from "./pages/SearchProducts";
import Payment from "./pages/Payment";
import Dashboard from "./pages/Dashboard";
import ProtectUser from "./utils/ProtectUser";
import Index from "./components/dashboard/Index";
import Orders from "./components/dashboard/Orders";
import ChangePassword from "./components/dashboard/ChangePassword";
import Wishlist from "./components/dashboard/Wishlist";
import OrderDetails from "./components/dashboard/OrderDetails";
import Chat from "./components/dashboard/Chat";
import ConfirmOrder from "./pages/ConfirmOrder";
import SeguimientoPedido from "./pages/SeguimientoPedido";
import Blogs from "./pages/Blogs";
import AtencionCliente from "./pages/AtencionCliente";

import CambiosyDevoluciones from "./pages/CambiosyDevoluciones";
import LibrodeReclamaciones from "./pages/LibrodeReclamaciones";
import PoliticadeSeguridadyPrivacidad from "./pages/PoliticadeSeguridadyPrivacidad";
import TerminosdeEnvios from "./pages/TerminosdeEnvios";
import TerminosyCondiciones from "./pages/TerminosyCondiciones";

import Nosotros from "./pages/Nosotros";
import NuestrasTiendas from "./pages/NuestrasTiendas";
import Ofertas from "./pages/Ofertas";

// Importar el ThemeProvider
import { ThemeProvider } from "./context/ThemeContext";

function App() {
  const dispatch = useDispatch();
  const { currentCompany } = useSelector((state) => state.init);

  useEffect(() => {
    // Disparar todas las acciones iniciales en un solo efecto
    dispatch(getFirstCompany());
    dispatch(getNavMenus());
    dispatch(get_category());
    dispatch(get_typeproduct());
    dispatch(get_typearticle());
    dispatch(get_brand());
    dispatch(get_color());
    dispatch(get_size());
  }, [dispatch]);

 /* useEffect(() => {
    if (currentCompany && currentCompany.icon) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = currentCompany.icon;
    }
  }, [currentCompany]);*/

useEffect(() => {
  if (currentCompany && currentCompany.icon) {
    // Forzamos HTTPS para evitar el error de "Mixed Content" en Vercel
    const iconUrl = currentCompany.icon.replace("http://", "https://");
    const versioning = `?v=${new Date().getTime()}`;

    const updateLink = (id, rel, type) => {
      let link = document.getElementById(id);
      if (link) {
        link.href = iconUrl + versioning;
        link.rel = rel;
        link.type = type; // Es buena práctica definir el tipo
      }
    };

    // Para PNG el type es "image/png"
    updateLink("dynamic-favicon", "icon", "image/png");
    updateLink("dynamic-apple-icon", "apple-touch-icon", "image/png");
    updateLink("dynamic-shortcut", "shortcut icon", "image/png");

    if (currentCompany.name) {
      document.title = currentCompany.name;
    }
  }
}, [currentCompany]);


  return (
    <ThemeProvider>
      <BrowserRouter>
       {/* <ScrollToTop /> */}
        <Routes>
          {/* Rutas principales */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/shops" element={<Shops />} />
          <Route path="/carrito" element={<Card />} />
          <Route path="/envio" element={<Shipping />} />
          <Route path="/pago" element={<Payment />} />

          {/* RUTAS DE PRODUCTOS CORREGIDAS */}
          {/* 1. Primero la ruta más específica */}
          <Route path="/products/search" element={<SearchProducts />} />

          {/* 2. Luego la ruta genérica (si todavía necesitas CategoryShop) */}
          <Route path="/products" element={<CategoryShop />} />

          {/* OPCIONAL: Si prefieres redirigir /products a /shops */}
          <Route path="/products" element={<Navigate to="/shops" replace />} />

          <Route path="/product/details/:slug" element={<Details />} />
          <Route path="/order/confirm" element={<ConfirmOrder />} />

          {/* Rutas de información y ayuda */}
          <Route path="/seguimiento-pedido" element={<SeguimientoPedido />} />
          <Route path="/blog" element={<Blogs />} />
          <Route path="/atencion-al-cliente" element={<AtencionCliente />} />
          <Route path="/cambios-y-devoluciones" element={<CambiosyDevoluciones />} />
          <Route path="/libro-de-reclamaciones" element={<LibrodeReclamaciones />} />
          <Route path="/politica-de-seguridad-y-privacidad" element={<PoliticadeSeguridadyPrivacidad />} />
          <Route path="/terminos-de-envios" element={<TerminosdeEnvios />} />
          <Route path="/terminos-y-condiciones" element={<TerminosyCondiciones />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/nuestras-tiendas" element={<NuestrasTiendas />} />
          <Route path="/ofertas" element={<Ofertas />} />

          {/* Dashboard protegido */}
          <Route path="/dashboard" element={<ProtectUser />}>
            <Route path="" element={<Dashboard />}>
              <Route path="" element={<Index />} />
              <Route path="my-orders" element={<Orders />} />
              <Route path="change-password" element={<ChangePassword />} />
              <Route path="my-wishlist" element={<Wishlist />} />
              <Route path="order/details/:orderId" element={<OrderDetails />} />
              <Route path="chat" element={<Chat />} />
              <Route path="chat/:sellerId" element={<Chat />} />
            </Route>
          </Route>

          {/* Redirección para rutas antiguas (opcional) */}
          <Route path="/category-shop" element={<Navigate to="/shops" replace />} />

          {/* Ruta 404 para manejar rutas no encontradas */}
          <Route
            path="*"
            element={
              <div className="min-h-screen flex items-center justify-center bg-gray-100">
                <div className="text-center">
                  <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
                  <p className="text-xl text-gray-600 mb-8">Página no encontrada</p>
                  <a href="/" className="px-6 py-3 bg-[#ae1d22] text-white rounded-lg hover:bg-red-800 transition-colors">
                    Volver al inicio
                  </a>
                </div>
              </div>
            }
          />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
